module.exports = __webpack_public_path__ + "img/62_1.06141821.png";